var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "admin-container" },
    [
      _c(
        "div",
        { staticClass: "admin-content-container" },
        [
          [
            _c("div", { staticClass: "bar-row justify-end" }, [
              _c(
                "div",
                { staticClass: "wl-search-bar" },
                [
                  !_vm.isKpmgUser
                    ? _c(
                        "el-button",
                        {
                          staticClass: "wl-green svg-btn",
                          on: {
                            click: function ($event) {
                              return _vm.exportList("template")
                            },
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "btn-icon",
                            attrs: {
                              src: require("@/assets/img/icon-export.svg"),
                              width: "100%",
                            },
                          }),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("admin.downloadTpl")) +
                              "\n                    "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      staticClass: "wl-green svg-btn",
                      attrs: { disabled: !_vm.hasPermission("download") },
                      on: {
                        click: function ($event) {
                          return _vm.exportList("list")
                        },
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "btn-icon",
                        attrs: {
                          src: require("@/assets/img/icon-export.svg"),
                          width: "100%",
                        },
                      }),
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("Export_exchange_Items")) +
                          "\n                    "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _c(
              "div",
              {
                class: [
                  "table-container-wrapper",
                  _vm.chooseable ? "show-table-bottom-operate" : "",
                ],
              },
              [
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading",
                      },
                    ],
                    ref: "exchangeTable",
                    staticClass: "wl-table",
                    attrs: {
                      height: "100%",
                      data: _vm.data,
                      border: "",
                      stripe: "",
                    },
                    on: { "selection-change": _vm.handleSelectionChange },
                  },
                  [
                    _vm.chooseable
                      ? _c("el-table-column", {
                          attrs: { type: "selection", width: "50" },
                        })
                      : _vm._e(),
                    _c("el-table-column", {
                      key: 1,
                      attrs: {
                        prop: "entityNameEn",
                        width: "500",
                        "show-overflow-tooltip": "",
                        label: _vm.$t("admin.entityNameEn"),
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function (scope) {
                            return [
                              _c("div", { staticClass: "table-header" }, [
                                _c(
                                  "div",
                                  { staticClass: "header-with-popup" },
                                  [
                                    _vm._v(
                                      "\n                              " +
                                        _vm._s(_vm.$t("admin.entityNameEn")) +
                                        "\n                              "
                                    ),
                                    _c("InputPopover", {
                                      attrs: {
                                        value: _vm.searchForm.entityNameEn,
                                        hidePopperSearch: _vm.hidePopperSearch,
                                      },
                                      on: {
                                        "update:value": function ($event) {
                                          return _vm.$set(
                                            _vm.searchForm,
                                            "entityNameEn",
                                            $event
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      key: 2,
                      attrs: {
                        prop: "entityNameCn",
                        width: "500",
                        "show-overflow-tooltip": "",
                        label: _vm.$t("admin.entityNameCn"),
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function (scope) {
                            return [
                              _c("div", { staticClass: "table-header" }, [
                                _c(
                                  "div",
                                  { staticClass: "header-with-popup" },
                                  [
                                    _vm._v(
                                      "\n                              " +
                                        _vm._s(_vm.$t("admin.entityNameCn")) +
                                        "\n                              "
                                    ),
                                    _c("InputPopover", {
                                      attrs: {
                                        value: _vm.searchForm.entityNameCn,
                                        hidePopperSearch: _vm.hidePopperSearch,
                                      },
                                      on: {
                                        "update:value": function ($event) {
                                          return _vm.$set(
                                            _vm.searchForm,
                                            "entityNameCn",
                                            $event
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      key: 3,
                      attrs: {
                        prop: "entityId",
                        width: "258",
                        "show-overflow-tooltip": "",
                        label: _vm.$t("admin.entityId"),
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function (scope) {
                            return [
                              _c("div", { staticClass: "table-header" }, [
                                _c(
                                  "div",
                                  { staticClass: "header-with-popup" },
                                  [
                                    _vm._v(
                                      "\n                              " +
                                        _vm._s(_vm.$t("admin.entityId")) +
                                        "\n                              "
                                    ),
                                    _c("InputPopover", {
                                      attrs: {
                                        value: _vm.searchForm.entityId,
                                        hidePopperSearch: _vm.hidePopperSearch,
                                      },
                                      on: {
                                        "update:value": function ($event) {
                                          return _vm.$set(
                                            _vm.searchForm,
                                            "entityId",
                                            $event
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      key: 4,
                      attrs: {
                        prop: "fapiaoRegistrationNumber",
                        width: "300",
                        "show-overflow-tooltip": "",
                        label: _vm.$t("admin.fapiaoRegistrationNumber"),
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function (scope) {
                            return [
                              _c("div", { staticClass: "table-header" }, [
                                _c(
                                  "div",
                                  { staticClass: "header-with-popup" },
                                  [
                                    _vm._v(
                                      "\n                              " +
                                        _vm._s(
                                          _vm.$t(
                                            "admin.fapiaoRegistrationNumber"
                                          )
                                        ) +
                                        "\n                              "
                                    ),
                                    _c("InputPopover", {
                                      attrs: {
                                        value:
                                          _vm.searchForm
                                            .fapiaoRegistrationNumber,
                                        hidePopperSearch: _vm.hidePopperSearch,
                                      },
                                      on: {
                                        "update:value": function ($event) {
                                          return _vm.$set(
                                            _vm.searchForm,
                                            "fapiaoRegistrationNumber",
                                            $event
                                          )
                                        },
                                      },
                                    }),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "ml-20",
                                        on: { click: _vm.toggleColumnShow },
                                      },
                                      [
                                        _c("svg-icon", {
                                          attrs: {
                                            iconName: _vm.renderIconName,
                                            size: "24",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          },
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "span",
                                {
                                  class: {
                                    "font-italic":
                                      scope.row.fapiaoRegistrationNumber ===
                                      "To be provided",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.fapiaoRegistrationNumber ===
                                        "To be provided"
                                        ? _vm.$t("admin.toProvided")
                                        : scope.row.fapiaoRegistrationNumber
                                    )
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm.columnShow
                      ? [
                          _c("el-table-column", {
                            key: 5,
                            attrs: {
                              prop: "fapiaoAddress",
                              width: "200",
                              "show-overflow-tooltip": "",
                              label: _vm.$t("admin.fapiaoAddress"),
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "header",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "table-header" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "header-with-popup",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "admin.fapiaoAddress"
                                                    )
                                                  ) +
                                                  "\n                                "
                                              ),
                                              _c("InputPopover", {
                                                attrs: {
                                                  value:
                                                    _vm.searchForm
                                                      .fapiaoAddress,
                                                  hidePopperSearch:
                                                    _vm.hidePopperSearch,
                                                },
                                                on: {
                                                  "update:value": function (
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      _vm.searchForm,
                                                      "fapiaoAddress",
                                                      $event
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "span",
                                        {
                                          class: {
                                            "font-italic":
                                              scope.row.fapiaoAddress ===
                                              "To be provided",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.fapiaoAddress ===
                                                "To be provided"
                                                ? _vm.$t("admin.toProvided")
                                                : scope.row.fapiaoAddress
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3478433429
                            ),
                          }),
                          _c("el-table-column", {
                            key: 6,
                            attrs: {
                              prop: "fapiaoPhoneNumber",
                              width: "200",
                              "show-overflow-tooltip": "",
                              label: _vm.$t("admin.fapiaoRegistrationNumber"),
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "header",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "table-header" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "header-with-popup",
                                            },
                                            [
                                              _vm._v(
                                                "\n                              " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "admin.fapiaoPhoneNumber"
                                                    )
                                                  ) +
                                                  "\n                              "
                                              ),
                                              _c("InputPopover", {
                                                attrs: {
                                                  value:
                                                    _vm.searchForm
                                                      .fapiaoPhoneNumber,
                                                  hidePopperSearch:
                                                    _vm.hidePopperSearch,
                                                },
                                                on: {
                                                  "update:value": function (
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      _vm.searchForm,
                                                      "fapiaoPhoneNumber",
                                                      $event
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "span",
                                        {
                                          class: {
                                            "font-italic":
                                              scope.row.fapiaoPhoneNumber ===
                                              "To be provided",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.fapiaoPhoneNumber ===
                                                "To be provided"
                                                ? _vm.$t("admin.toProvided")
                                                : scope.row.fapiaoPhoneNumber
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2841398997
                            ),
                          }),
                          _c("el-table-column", {
                            key: 7,
                            attrs: {
                              prop: "bankAccount",
                              width: "200",
                              "show-overflow-tooltip": "",
                              label: _vm.$t("admin.fapiaoRegistrationNumber"),
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "header",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "table-header" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "header-with-popup",
                                            },
                                            [
                                              _vm._v(
                                                "\n                              " +
                                                  _vm._s(
                                                    _vm.$t("admin.bankAccount")
                                                  ) +
                                                  "\n                              "
                                              ),
                                              _c("InputPopover", {
                                                attrs: {
                                                  value:
                                                    _vm.searchForm.bankAccount,
                                                  hidePopperSearch:
                                                    _vm.hidePopperSearch,
                                                },
                                                on: {
                                                  "update:value": function (
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      _vm.searchForm,
                                                      "bankAccount",
                                                      $event
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "span",
                                        {
                                          class: {
                                            "font-italic":
                                              scope.row.bankAccount ===
                                              "To be provided",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.bankAccount ===
                                                "To be provided"
                                                ? _vm.$t("admin.toProvided")
                                                : scope.row.bankAccount
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3613094229
                            ),
                          }),
                          _c("el-table-column", {
                            key: 8,
                            attrs: {
                              prop: "bankAccountHolder",
                              width: "200",
                              "show-overflow-tooltip": "",
                              label: _vm.$t("admin.fapiaoRegistrationNumber"),
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "header",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "table-header" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "header-with-popup",
                                            },
                                            [
                                              _vm._v(
                                                "\n                              " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "admin.bankAccountHolder"
                                                    )
                                                  ) +
                                                  "\n                              "
                                              ),
                                              _c("InputPopover", {
                                                attrs: {
                                                  value:
                                                    _vm.searchForm
                                                      .bankAccountHolder,
                                                  hidePopperSearch:
                                                    _vm.hidePopperSearch,
                                                },
                                                on: {
                                                  "update:value": function (
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      _vm.searchForm,
                                                      "bankAccountHolder",
                                                      $event
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "span",
                                        {
                                          class: {
                                            "font-italic":
                                              scope.row.bankAccountHolder ===
                                              "To be provided",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.bankAccountHolder ===
                                                "To be provided"
                                                ? _vm.$t("admin.toProvided")
                                                : scope.row.bankAccountHolder
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3668109013
                            ),
                          }),
                        ]
                      : _vm._e(),
                    _c("el-table-column", {
                      key: 9,
                      attrs: {
                        width: "100",
                        label: _vm.$t("TABLE_HEAD_COMMENTS"),
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "header-with-popup header-one-center",
                                },
                                [
                                  _vm._v(
                                    "\n                                  " +
                                      _vm._s(_vm.$t("TABLE_HEAD_COMMENTS")) +
                                      "\n                                  "
                                  ),
                                  _c("DatePickerPopover", {
                                    attrs: {
                                      value: _vm.searchForm.commentDate,
                                      hidePopperSearch: _vm.hidePopperSearch,
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        return _vm.$set(
                                          _vm.searchForm,
                                          "commentDate",
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex item-center justify-center",
                                },
                                [
                                  _c("i", {
                                    class: [
                                      scope.row.todayCommentCount > 0
                                        ? "wl-icon-messageBoard"
                                        : "wl-icon-messageBoardNull",
                                      "el-icon-s-comment",
                                    ],
                                    on: {
                                      click: function ($event) {
                                        return _vm.toogleMessageBoardVisible(
                                          scope.row
                                        )
                                      },
                                    },
                                  }),
                                  scope.row.todayCommentCount
                                    ? _c("span", [
                                        _c(
                                          "span",
                                          { staticClass: "message-today" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.todayCommentCount
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("span", [_vm._v("/")]),
                                      ])
                                    : _vm._e(),
                                  scope.row.messageNum > 0
                                    ? _c("span", [
                                        _vm._v(
                                          " " + _vm._s(scope.row.messageNum)
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  2
                ),
              ],
              1
            ),
            _vm.chooseable
              ? _c(
                  "div",
                  { staticClass: "footer-btn" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "cancel-btn",
                        attrs: { disabled: !_vm.chooseable },
                        on: { click: _vm.cancelChoose },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("btn_cancel")) +
                            "\n                "
                        ),
                      ]
                    ),
                    _vm.chooseable && _vm.multiChoose.mode == "download"
                      ? _c(
                          "el-button",
                          {
                            staticClass: "wl-green",
                            attrs: {
                              disabled:
                                _vm.chooseable &&
                                _vm.multipleSelection.length == 0,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.tooglebatchDownLoad("download")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$t("COMMON_DOWNLOAD")) +
                                "\n                "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "el-pagination",
              {
                staticClass: "wl-pagination",
                attrs: {
                  "current-page": _vm.pagination.pageNum,
                  "page-size": _vm.pagination.pageSize,
                  layout: "prev, pager, next, slot, total",
                  total: _vm.pagination.total,
                },
                on: {
                  "current-change": _vm.onCurrentPageChange,
                  "size-change": _vm.onSizeChange,
                },
              },
              [
                _c(
                  "span",
                  [
                    _c(
                      "el-select",
                      {
                        on: { change: _vm.onSizeChange },
                        model: {
                          value: _vm.pagination.pageSize,
                          callback: function ($$v) {
                            _vm.$set(_vm.pagination, "pageSize", $$v)
                          },
                          expression: "pagination.pageSize",
                        },
                      },
                      _vm._l(_vm.pageOptions, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ],
        ],
        2
      ),
      _vm.messageBoardVisible
        ? _c("messageBoard", {
            attrs: {
              initData: _vm.rowData,
              onCancel: _vm.toogleMessageBoardVisible,
              onAdd: _vm.getTableList,
              messageType: "7",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }